import globalAxios, { AxiosInstance, AxiosResponse, RawAxiosRequestConfig } from 'axios'
import { BASE_PATH } from '../../network/base'
import { Configuration } from '../../network/configuration'
import { CreateCategoryResponse, LocalizedName, UpdateCategoryResponse } from '../../network/model'

/**
 * MultipartServicesApi - interface
 * @export
 * @interface MultipartServicesApi
 */

export interface IMultipartServicesApi {
  /**
   *
   * @summary Submit a new category
   * @param {File} icon Category image file
   * @param {LocalizedName} description
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesActivitiesApiInterface
   */
  createCategory(icon: File, description: LocalizedName): Promise<AxiosResponse<CreateCategoryResponse>>

  /**
   *
   * @summary Update category
   * @param {string} categoryId
   * @param {File} [icon] Category image file
   * @param {LocalizedName} [description]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesActivitiesApiInterface
   */
  updateCategory(categoryId: string, icon?: File, description?: LocalizedName): Promise<AxiosResponse<UpdateCategoryResponse>>
}

/**
 * MultipartServicesApi - object-oriented interface
 * @export
 * @class MultipartServicesApi
 */
export class MultipartServicesApi implements IMultipartServicesApi {
  protected configuration: Configuration | undefined

  constructor(
    configuration?: Configuration,
    protected basePath: string = BASE_PATH,
    protected axios: AxiosInstance = globalAxios
  ) {
    if (configuration) {
      this.configuration = configuration
      this.basePath = configuration.basePath ?? basePath
    }
  }

  /**
   *
   * @summary Submit a new category
   * @param {File} icon Category image file
   * @param {LocalizedName} description
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesActivitiesApiInterface
   */
  public async createCategory(icon: File, description: LocalizedName): Promise<AxiosResponse<CreateCategoryResponse>> {
    const formData = new FormData()

    for (const language of Object.entries(description)) {
      formData.append(`description[${language[0]}]`, language[1])
    }
    formData.append('icon', icon)

    const config: RawAxiosRequestConfig = {
      method: 'post',
      url: `${this.basePath}/admin/category`,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: formData
    }

    return await this.axios(config)
  }

  /**
   *
   * @summary Update category
   * @param {string} categoryId
   * @param {File} [icon] Category image file
   * @param {LocalizedName} [description]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesActivitiesApiInterface
   */
  public async updateCategory(categoryId: string, icon?: File, description?: LocalizedName): Promise<AxiosResponse<UpdateCategoryResponse>> {
    const formData = new FormData()

    if (description) {
      for (const language of Object.entries(description)) {
        formData.append(`description[${language[0]}]`, language[1])
      }
    }
    if (icon) {
      formData.append('icon', icon)
    }
    const config: RawAxiosRequestConfig = {
      method: 'put',
      url: `${this.basePath}/admin/category/${categoryId}`,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: formData
    }

    return await this.axios(config)
  }
}
